import { connect } from "react-redux";

import { ConsentPage } from "../screens/ConsentsPage";
import { onChangeConsentForm, consentFormValidateAndSubmit } from "../reducers/consentForm";

function mapStateToProps(state) {
    const offer = state.offer;
    const form = state.consentFormReducer;
    const globalFormFields = state.globalFormFieldsReducer;
    return {
        offer, form, globalFormFields
    }
}

function mapDispatchToProps(dispatch) {
    return {
        onChangeField: (name, value) => dispatch(onChangeConsentForm(name, value)),
        submit: finished => dispatch(consentFormValidateAndSubmit(finished))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConsentPage);